import { useTranslation } from 'react-i18next';

import { DataPanel, DataPanelAutoWrapInlineItem } from '@/ui';
import type { Caller } from '@/signalr';
import { CallerClassificationPanelItem } from '../shared/CallerClassificationPanelItem';
import { ClosePersonContactPanelItem } from '../shared/ClosePersonContactPanelItem';
import { SourceUnavailablePanelItem } from '../shared/SourceUnavailablePanelItem';
import { DeviceStatusRow } from './DeviceStatusRow';
import { MobileAppMedicDataPanelItems } from './MobileAppMedicDataPanelItems';

export type MobileAppSectionProps = {
  sources: Caller['dataSources']['mobileApp'];
  deviceInfo: Caller['deviceInfo'];
  createdTimeUtc: string;
};

export function MobileAppSection({ sources, deviceInfo, createdTimeUtc }: MobileAppSectionProps) {
  const { t } = useTranslation();
  const source = sources[0];

  if (source == null) {
    return null;
  }

  return (
    <DataPanel header={t('Incident_InfoPanel_MobileAppData')}>
      {source.data == null ? (
        <SourceUnavailablePanelItem sourceId={source.sourceId} />
      ) : (
        <>
          <DeviceStatusRow deviceInfo={deviceInfo} />

          <CallerClassificationPanelItem classification={source.data.classification} />

          <MobileAppMedicDataPanelItems medicData={source.data.medicData} createdTimeUtc={createdTimeUtc} />

          <DataPanelAutoWrapInlineItem
            title={t('Incident_InfoPanel_PermanentResidence')}
            value={source.data.permanentResidence?.fullAddress ?? undefined}
            showEmptyPlaceholder
          />

          <DataPanelAutoWrapInlineItem
            title={t('Incident_InfoPanel_Languages')}
            value={source.data.languages.join(', ')}
            showEmptyPlaceholder
          />

          <ClosePersonContactPanelItem contacts={source.data.contacts} />
        </>
      )}
    </DataPanel>
  );
}
